export default {
  setEventId (state, eventId) {
    state.eventId = eventId
  },

  setEventQuizset (state, eventQuizset) {
    state.eventQuizset = eventQuizset
  },

  setQuizset (state, quizset) {
    state.quizset = quizset
  }
}
